export const jobTriggersQueryKey = (jobId: number) => ['journey-triggers', jobId];

export const availableJourneysQueryKeyPrefix = (jobId: number) => [
  'journey-available-journeys',
  jobId,
];

export const availableJourneysQueryKey = (jobId: number, search: string) => [
  ...availableJourneysQueryKeyPrefix(jobId),
  search,
];

export const jobTriggerCountQueryKey = (jobId: number) => ['journey-trigger-count', jobId];

export const jobJourneyConfigQueryKeyPrefix = ['job-journey-config'];

export const jobJourneyConfigQueryKey = (jobId: number, journeyId: string) => [
  ...jobJourneyConfigQueryKeyPrefix,
  jobId,
  journeyId,
];
